<template>
    <div class="venue__edit">
        <div class="venue__edit_header is-touch">
            <view-actions
                    :title="`${$t('ebs.venues.edit.title.editing')} ${venueName}`"
                    :notify-title="$t('ebs.venues.edit.title.notifyVenue')"
                    :notify-process="$t('ebs.venues.edit.title.stopEditing')"
                    :cancel-button-text="venueAllowEdit ? this.$t('ebs.venues.edit.buttons.stopEditing') : this.$t('ebs.venues.edit.buttons.goBack')"
                    :cancel-notify-active="venueAllowEdit"
                    :submit-button-active="false"
                    :trash-button-active="true"
                    :breadcrumb-active="true"
                    :breadcrumb-items="[
                        {
                            name: this.$t('ebs.venues.edit.name.venues'),
                            to: { name: 'ebs-venue-list' }
                        }
                    ]"
                    @emit-cancel="venueAllowEdit ? null : venueStopEdit()"
                    @emit-notify-remove-submit="venueRemove"
                    @emit-notify-cancel-submit="venueStopEdit"
            />
        </div>
        <div class="venue__edit_main">
            <div class="container">
                <div class="columns change--centered">
                    <div class="column column--center is-6-desktop is-10-tablet is-12-mobile">
                        <venue-edit-form/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ViewActions from '@/components/default/shared/ViewActions'
import VenueEditForm from '@/components/ebs/venues/edit/VenueEditForm'

export default {
  components: {
    VenueEditForm,
    ViewActions },
  name: 'venue-edit',
  computed: {
    venueName: function () {
      return this.$store.getters['getVenueName']
    },
    venueAllowEdit () {
      return this.$store.getters.getVenueAllowEdit
    }
  },
  methods: {
    allowRedirectBeforeRouteLeave: function () {
      this.$eventBus.$emit('venue-submit')
    },
    //
    venueRemove: function () {
      this.allowRedirectBeforeRouteLeave()
      this.$store.dispatch('removeVenue', this.$route.params.id)
    },
    venueStopEdit: function () {
      this.$store.dispatch('resetVenue')
      this.allowRedirectBeforeRouteLeave()
      this.$router.push({ name: 'ebs-venue-show', params: { id: this.$route.params.id } })
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/venues/venueaddedit";
</style>
